import { useTranslation } from 'react-i18next';
import { CONTACT_US_LINK } from '~components/organization/UserMenu';
import { PolicyPage } from '~components/ui/PolicyPage';

// See PolicyPage.tsx for content generation instructions.
export function ServiceSchedulePage() {
  const { t } = useTranslation();

  return (
    <PolicyPage title={t('service_schedule')} heading={t('ppds_wave')}>
      <div
        dangerouslySetInnerHTML={{
          __html: t('serviceSchedule', { contactusUrl: CONTACT_US_LINK }),
        }}
      />
    </PolicyPage>
  );
}
